var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b(),on:{"click":_vm.onClickRemove}},[_c('div',{class:_vm.b('key')},[_vm._v(_vm._s(_vm.filter.name))]),_c('div',{class:_vm.b('value')},[_vm._v(_vm._s(_vm.filter.text))]),_c('div',{class:_vm.b('close')},[_c('v-icon',[_vm._v("mdi-close")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }